<app-content-header
  (backEvent)="back.emit()"
  [historyBack]="historyBack"
  [headline]="'select_invoice_contact_headline' | i18next"
  [hint]="!isPC20CSP ? ('select_invoice_contact_hint' | i18next) : ''">
</app-content-header>

<div class="row mt-5">
  @if (!isCreating) {
    <app-icon-card class="col-md-8 offset-md-2 mb-3" headline="select_invoice_choose_contact">
      <div class="d-flex flex-column w-100">
        <p-select class="w-100"
          optionLabel="label"
          optionValue="value"
          [options]="multiselectableContacts"
          [(ngModel)]="selectedContact"
          [emptyMessage]="'app_empty_multiselect' | i18next"
          [filter]="true"
          filterBy="label">
        </p-select>
      </div>
      <div class="d-flex justify-content-end mt-3 form-container-footer">
        <button class="btn btn-outline-primary" (click)="onAddContact()">
          {{ 'select_invoice_add_contact_button' | i18next }}
        </button>
        <button class="btn btn-primary" (click)="selectContact()">{{ 'select_invoice_contact_select_button' | i18next }}</button>
      </div>
    </app-icon-card>
  }
  @if (isCreating) {
    <app-select-invoice-contact-create [companyId]="customer.id" (created)="onContactCreated($event)" class="col-md-8 offset-md-2 mb-3">
      @if (multiselectableContacts.length > 0) {
        <button class="btn btn-link" (click)="isCreating = false">
          {{ 'select_invoice_contact_select_existing_button' | i18next }}
        </button>
      }
    </app-select-invoice-contact-create>
  }
</div>


